export default "__VITE_ASSET__wYal9pTG__"